import { authLayout } from "../helpers/withAuth";

export const itemRoutes = {
  path: "item",
  ...authLayout("Item", [
    {
      path: "/item/search",
      lazy: () =>
        import("../../modules/item/pages/search/index").then((m) => ({
          Component: m.default,
        })),
    },
    {
      path: "/item/:id",
      lazy: () =>
        import("../../modules/item/item").then((m) => ({
          Component: m.default,
        })),
    },
    {
      path: "/item/talent/:id",
      lazy: () =>
        import("../../modules/talent/cast").then((m) => ({
          Component: m.default,
        })),
    },
  ]),
};
